import { FC, useMemo } from 'external/react'
import PaymentMethod from './PaymentMethod'
import SubscriptionStatus from './SubscriptionStatus'
import SubscriptionAction from './SubscriptionAction'
import { PaymentItemOptions } from './PaymentItemOptions'

type PaymentItemProps = {
    index: number
    handleOpenDetail: (index:number) => void
    handleChangePaymentMethod: (index: number) => void
    handleItemAction: (index:number, status: string) => void
    payment: any
}

const PaymentItem:FC<PaymentItemProps> = props => {

    const {payment, index, handleOpenDetail, handleItemAction, handleChangePaymentMethod} = props
    const {offerName, plan_alias, price, frequencyUnit} = payment

    const frequency = useMemo(() => frequencyUnit == 'month' ? 'mensual' : 'anual', [frequencyUnit])
    
	return (
        <div className='shadow-sm card mb-3' style={{ borderRadius: '10px' }}>
            <div className='card-body px-0'>
                <div className='text-black d-flex' style={{ padding: '0px 10px' }} >
                    <div className='col-md-3'>
                        <p className='text-capitalize fn-s-18 fw-bold-500 m-auto'>
                            {offerName}{' '} <span className='fn-s-14'> ({plan_alias}) </span>
                        </p>
                        <span className='fn-s-14'>
                            {price} / {frequency}{' '}
                        </span>
                    </div>
                    <PaymentMethod className='col-md-3 flex-column' card={payment.card} last4={payment.last4} />
                    <SubscriptionStatus className='col-md-3' paymentMode={payment.paymentMode} periondEnds={payment.subscriptionEnds} status={payment.subscriptionStatus} />
                    {payment.paymentMode === 'subscription' && <SubscriptionAction index={index} onClick={handleItemAction} status={payment.subscriptionStatus} />}
                    <div className='flex-grow-1' />
                    <div className='d-flex flex-column justify-content-center'>
                        <PaymentItemOptions index={index} handleOpenDetail={handleOpenDetail} payment={payment} handleChangePaymentMethod={handleChangePaymentMethod} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export {PaymentItem as default}